import Vue from 'vue'
import Router from 'vue-router'
import Pass from '@/components/pass/Pass.router'
// import Hello from '@/components/pass/Hello'
import Login from '@/components/pass/Login'
import Register from '@/components/pass/Register'
import Home from '@/components/home/home'
// import AppConsole from '@/components/app_console/index'
// import List from '@/components/app_console/list'
let AppConsole = ()=>import('@/components/app_console/index')
let List = ()=>import('@/components/app_console/list')
let App = ()=>import('@/components/app_console/app')

Vue.use(Router)

export default new Router({
  base:'/www',
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: {
        title: '信息复制网'
      }
    },
    {
      path:'/app_console',
      name:'console',
      component: AppConsole,
      meta:{
        title: '应用控制中心'
      },
      children: [
        {
          path:'',
          name:'list',
          component: List,
          meta:{
            title: '应用控制中心'
          },
        },{
          path:'app/:id',
          name:'app',
          component:App,
          meta:{
            title: '应用控制中心'
          },
        }
      ]
    },
    {
      path: '/auth',
      name: 'Pass',
      component: Pass,
      children:[
        // {
        //   path: 'hello',
        //   name: 'Hello',
        //   component: Hello,
        //
        // },
        {
          path: 'login',
          name: 'Login',
          component: Login,
          alias:'/login'
        },
        {
          path: 'register',
          name: 'Register',
          component: Register,
        }
      ]
    },

  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js